/**
 * Created by Rene Lopez on 26/10/16.
 */

// EmailServerDetailsView.js

import $ from 'jquery';
import _ from 'lodash';
import BasePropertyView from 'BasePropertyView.js';
import { Model } from 'backbone';
import NotificationService from 'NotificationService.js';
import RestService from 'RestService.js';
import undoService from 'UndoService.js';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import contentTemplate from 'dashboard/settings/email-server-details-view.ejs';
import SimpleConfirmModal from 'common-views/SimpleConfirmModalView.js';
import TestEmailServerModal from 'common-views/TestEmailServerModalView.js';
import TestEmailConfirmationModal from 'common-views/TestEmailConfirmationModalView.js';
import textConstants from 'TextConstants';
import listService from 'ListService.js';
import dashboardService from 'DashboardService';
import util from 'util/Util';
import Spinner from 'spin/spin';
import ConfirmationModal from 'dashboard/forms/modal/ConfirmationModal';


class EmailServerDetailsView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {
            'keyup input[type=text], input[type=password]': 'enableChangesSection',
            'change input[type=text], input[type=password], select': 'updateInputsAndDropdowns',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=checkbox]': 'updateCheckboxes',
            'blur input[name=Address]': 'checkSMTPProvider',
            'click input[name=applyChanges]': 'checkGoogleSMTP',
            'click input[name=cancelChanges]': 'cancelChanges',
            'click input[name=makeDefault]': 'makeDefault',
            'click input[name=clearDefault]': 'clearDefault',
            'click input[name=delete]': 'deleteServer',
            'click input[name=test]': 'testEmailServer',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToAccountSettings'
        };

        this.getEmailServerProviders();
        this.firstLoad = true;

        this.model.set('emailServers', listService.emailServers.filter(e => e['@EmailServerId'] !== this.model.get('emailServerId')), { silent: true });

        if(!this.model.get('currentEmailServerDetails').SecondaryEmailServerID){
            let current = this.model.get('currentEmailServerDetails');
            current.SecondaryEmailServerID = -1;
            this.model.set('currentEmailServerDetails', current, { silent: true });
        }
        if (this.model.get('currentEmailServerDetails').SecondaryEmailServerID >= 0) {
            let current = this.model.get('currentEmailServerDetails');
            current.requireSecondaryEmailServer = 'True';
            this.model.set('currentEmailServerDetails', current, { silent: true });
        }

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    checkGoogleSMTP(dontApplyChanges){
        const domains = ["gmail", "google"];
        const serverAddress = $('input[name="Address"]').val();
        const provider = $('#EmailSendProviderId').val();
        const isNew = util.isTrue(sessionStorage.getItem("isNewServer"));
        
        const isGoogle = domains.some((val)=>{
            return serverAddress.indexOf(val) >= 0;
        });

        if(isGoogle && provider === "basic"){
            const expireDate = new Date('2024-10-30'); //Show the date in the message until october 30th
            const currentDate = new Date();

            let confirmationTitle = ""
            let confirmationText = ""

            let buttons;

            if(!isNew){
                //if it is an existing connection
                if (expireDate > currentDate) {
                    confirmationTitle = "Email Configuration Change Suggested"
                    confirmationText = "The basic authentication used by the Google SMTP server will no longer be supported as of September 30, 2024. Would you like to change your Google SMTP server to OAuth now?";
                }
                else {
                    confirmationTitle = "Email Configuration Change Required"
                    confirmationText = "The basic authentication used by the Google SMTP server is no longer supported. Your email notifications are not being delivered. Would you like to change your Google SMTP server to OAuth for continued email functionality within the application?";
                }
                buttons = [
                    {
                        text: 'Yes, Change to OAuth',
                        resolve: "yes"
                    },
                    {
                        text: 'No, Keep Configuration',
                        resolve: "no"
                    }];

            }
            else{
                confirmationTitle = "Email Configuration Change Required"
                    
                if (expireDate > currentDate) {
                    confirmationText = "The basic authentication used by the Google SMTP server will no longer be supported as of September 30, 2024. The Server Type will be automatically changed to OAuth for continued email functionality within the application.";
                }
                else {
                    confirmationText = "The basic authentication used by the Google SMTP server is no longer supported. The Server Type will be automatically changed to OAuth for continued email functionality within the application.";
                }
                buttons = [
                    {
                        text: 'OK',
                        resolve: "yes"
                    }];
            }

            new ConfirmationModal({
                model: new Model({
                    confirmationTitle: confirmationTitle,
                    confirmationText: confirmationText,
                    height: "auto",
                    width: 500,
                    buttons
                })
            }).render().then(result => {
                if(result === "yes"){
                    //Change to google oauth
                    $('#EmailSendProviderId').val("2").trigger("change")

                    //Launch authentication
                    $("#getToken").trigger("click");
                }
                else{//keep configuration
                    if(!dontApplyChanges){
                        this.applyChanges();
                    }
                }
            });
        }
        else{ //If not a google basic connection continue normal process
            this.applyChanges();
        }
    }

    checkSMTPProvider(){

        const isNew = util.isTrue(sessionStorage.getItem("isNewServer"));

        //Only validate on address change if the connection is new
        if(isNew){
            this.checkGoogleSMTP(true);
        }
    }

    _showChangesSection() {
        if (!util.isTrue(this.model.get('hasChanges'))) {
            this.model.set('hasChanges', true, { silent: true });
            $('#actionsSection').addClass('hide');
            $('#changesSection').removeClass('hide');
        }
    }

    enableChangesSection(ev) {
        
        // PF-5944 Validate if text actually changed
        if(!ev.target.readOnly){
            if (this.model.get('emailServerDetails')[ev.target.name]) {
                if (this.model.get('emailServerDetails')[ev.target.name] !== ev.target.value) {
                    this._showChangesSection();
                }
            } else {
                this._showChangesSection();
            }
        }
    }
    
    authenticate(event){
        console.log('Modal closed', event);
        if (window.redirect_uri.includes(event.origin)) {
            try {
                const code = event.data[0].code;
                window.currentModel.checkUserAuthenticated(code);
                $(constants.LOADING).hide();
            }
            catch (err) {
                console.log(err);
                $(constants.LOADING).hide();
            }
        }
    }

    redirectSignIn(signInURL) {

        const spinner = $(constants.LOADING);
        spinner.find('h4').text('Authenticating user... \n Please finish the authentication process in the popup window.');
        spinner.show();

        window.currentModel = this;

        window.removeEventListener("message", this.authenticate, true);
        window.addEventListener("message", this.authenticate, true);

        const urlParams = new URLSearchParams(signInURL);
        const uri = urlParams.get('redirect_uri');
        window.redirect_uri = uri;
        
        setTimeout(() => {
            //const returnParam = "s.0.Resources" + ".wellEmailsGroup." + this.model.get("emailServerId");
            const returnParam = "";
            const popup = util.popupWindow(signInURL + "&state=" + returnParam, window, 550, 700);

            const checkPopup = setInterval(() => {
                if (!popup) {
                    window.alert(constants.POPUP_BLOCKER_MESSAGE);
                    spinner.hide(); 
                    clearInterval(checkPopup);               
                }
                else if(popup.closed){
                    spinner.hide(); 
                    clearInterval(checkPopup);       
                }

            }, 400);
        }, 200);
    }

    checkUserAuthenticated(code) {

        const model = this.model || window.currentModel;

        const currentEmailServerModel = model.get('currentEmailServerDetails');
        const emailServerId = model.get("emailServerId");
        const oAuthProviderId = currentEmailServerModel.oAuthProviderId;
        const OAuthCredentialId = currentEmailServerModel.OAuthCredentialId;

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        if (code && code != "") {
            RestService.validateOAuthCode(oAuthProviderId, emailServerId, code).then((response) => {

                currentEmailServerModel.UserName = response.UserName;
                currentEmailServerModel.EmailAddress = response.UserName;
                currentEmailServerModel.OAuthCredentialId = response.OAuthCredentialId;

                $("#oAuthAccount").val(response.UserName);
                $("#emailAddress").val(response.UserName);
                $("#oAuthStatus").val("Connected");

                this.model.set('currentEmailServerDetails', currentEmailServerModel, { silent: true });
                this._showChangesSection();
                spinner.stop();

            }).catch((err) => {

                $("#oAuthAccount").val("");
                $("#emailAddress").val("");
                $("#oAuthStatus").val("Not Connected");
                const errMsg = typeof(err) === 'string' ? err : (err.MESSAGE ? err.MESSAGE : 'Unknown Error');
                NotificationService.error(errMsg);

                console.log('Error: ' + errMsg);
                spinner.stop();
            });
        }
        else {
            if(OAuthCredentialId && OAuthCredentialId != ""){
                RestService.validateOAuthCredential(currentEmailServerModel.OAuthCredentialId).then((response) => {

                    currentEmailServerModel.UserName = response.UserName;

                    $("#oAuthAccount").val(response.UserName);
                    $("#emailAddress").val(response.UserName);
                    $("#oAuthStatus").val("Connected");

                    this.model.set('currentEmailServerDetails', currentEmailServerModel, { silent: true });
                    spinner.stop();

                }).catch((err) => {

                    $("#oAuthAccount").val("");
                    $("#oAuthStatus").val("Not Connected");
                    $("#emailAddress").val("");
                    NotificationService.error(err);
                    
                    console.log('Error: ', err);
                    spinner.stop();
                });
            }
        }

        spinner.stop();
    }

    changeLayout(providerId, method) {

        switch (method) {
            case "2":                
                $(".smtp").hide();
                $(".advanced").hide();
                $(".oAuth").show();
                $("#emailAddress").prop('readonly', true);
                break;
            default:
                $(".smtp").show();
                $(".advanced").show();
                $(".oAuth").hide();
                $("#emailAddress").prop('readonly', false);
                break;
        }

        if (providerId) {
            
            let currentEmailServerModel = this.model.get('currentEmailServerDetails');

            if (method && method !== "1") {                
                const providers = this.model.get('serverProviders');
                let provider = providers.filter(prv => prv['@EmailSendProviderId'] === providerId);

                const buttonIcon = $("#getToken");
                buttonIcon[0].src = "data:image/png;base64," + provider[0]['@ButtonIcon'];
                this.getEmailServerTypeDetails(provider[0]['@OAuthProviderId']);

                currentEmailServerModel.Address = provider[0]['@ServerAddress'];
                currentEmailServerModel.Port = provider[0]['@Port'];
                currentEmailServerModel.SSL = provider[0]['@SSL'];
                currentEmailServerModel.RequiresAuthentication = true;
                currentEmailServerModel.oAuthProviderId = provider[0]['@OAuthProviderId'];
                currentEmailServerModel.EmailSendProviderId = provider[0]['@EmailSendProviderId'];
                currentEmailServerModel.OAuthCredentialId = null;

                this.model.set('currentEmailServerDetails', currentEmailServerModel, { silent: true });

                if (this.firstLoad) {
                    this.checkUserAuthenticated();
                }

                $(`select[name='EmailSendProviderId'] option[value="${provider[0]['@EmailSendProviderId']}"]`).prop('selected', true);
            }
            else {

                const basicDefaults = constants.BASIC_EMAIL_SERVER_DEFAULTS;

                currentEmailServerModel.Address = basicDefaults.address;
                currentEmailServerModel.Port = basicDefaults.port;
                currentEmailServerModel.SSL = basicDefaults.ssl;
                currentEmailServerModel.RequiresAuthentication = basicDefaults.requiresAuthentication;
                currentEmailServerModel.EmailSendProviderId = null;
                currentEmailServerModel.oAuthProviderId = null;
                currentEmailServerModel.OAuthCredentialId = null;

                currentEmailServerModel.UserName = basicDefaults.userName;
                currentEmailServerModel.EmailAddress = basicDefaults.emailAddress;

                this.model.set('currentEmailServerDetails', currentEmailServerModel, { silent: true });
                this.render();
            }
        }

        this.firstLoad = false;

        return method;
    }

    updateInputsAndDropdowns(ev) {
        let prop = ev.target.name;
        let value = ev.target.value;
        let emailServerDetails = this.model.get('currentEmailServerDetails');
        emailServerDetails[prop] = value;

        if (prop === "EmailSendProviderId") {

            const selectedIndex = ev.target.selectedIndex;
            const selection = ev.target.options[selectedIndex];
            const method = selection.dataset["method"];

            emailServerDetails["AuthMethod"] = method;
            emailServerDetails["UserName"] = '';    
            $("#oAuthAccount").val("");
            $("#emailAddress").val("");
            $("#oAuthStatus").val("Not Connected");
            this.changeLayout(value, method);
        }

        this.model.set('currentEmailServerDetails', emailServerDetails, { silent: true });
        this._showChangesSection();
    }

    updateCheckboxes(ev) {
        let prop = ev.target.name;
        let value = ev.target.checked ? "True" : "False";
        let emailServerDetails = this.model.get('currentEmailServerDetails');
        console.log('Current Email Server Details Before Update', emailServerDetails);
        emailServerDetails[prop] = value;
        this.model.set('currentEmailServerDetails', emailServerDetails, { silent: true });
        this.model.set('hasChanges', true);
        console.log('Current Email Server Details After Update', this.model.get('currentEmailServerDetails'));
        this.render();
    }

    updateEmailServerSettings() {
        const currentEmailServerModel = this.model.get('currentEmailServerDetails');
        const updatedServer = this.parseServerParams(currentEmailServerModel);

        const originalEmailServerModel = this.model.get('emailServerDetails');
        const originalServer = this.parseServerParams(originalEmailServerModel);

        undoService.add({
            undo: () => {
                this.persistUpdate(originalServer);
            },
            redo: () => {
                this.persistUpdate(updatedServer);
            }
        }, textConstants.UNDO_UPDATE_EMAIL_SVR);

        this.persistUpdate(updatedServer);
        util.setUndoRedoAccess();
    }

    persistUpdate(data) {
        RestService.updateEmailServerDetails(data).then((updateResponse) => {
            console.log('Updated Email Server Response', updateResponse);
            if (listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_UPDATE_EMAIL_SERVER_DETAILS, this.model.get('emailServerId'));
            }
        }).catch((err => {
            console.log('Error Applying changes on Server Details', err);
            NotificationService.error('Error Applying changes on Server Details' + err.MESSAGE);
        }));
    }

    parseServerParams(model) {

        const params = {};

        params.emailServerId = this.model.get('emailServerId');
        params.name = model.Name;
        params.address = model.Address;
        params.port = !model.Port ? '0' : model.Port;
        params.displayName = model.DisplayName;
        params.emailAddress = model.EmailAddress;
        params.replyToDisplayName = model.ReplyToDisplayName;
        params.replyToEmailAddress = model.ReplyToEmailAddress;
        params.userName = model.UserName;
        params.password = model.password;
        params.ssl = model.SSL === 'True';
        params.requiresAuthentication = model.RequiresAuthentication === 'True';
        params.sendFailureEmail = model.SendFailureEmail === 'True'; 
        params.secondEmailServer = parseInt(model.requireSecondaryEmailServer === 'True' ? model.SecondaryEmailServerID : -1);
        
        if(model.SendFailureEmailFrequency){
            params.failureEmailFreq = parseInt(model.SendFailureEmailFrequency);
        }
        if(model.SMTPTimeout){
            params.smtpTimeout = parseInt(model.SMTPTimeout);
        }        
        
        if(model.NoofRetry){
            params.noOfRetry = parseInt(model.NoofRetry);
        }
        
        params.AuthMethod = model.AuthMethod;

        if (model.EmailSendProviderId){
            params.emailSendProviderId  = parseInt(model.EmailSendProviderId);
        }

        if (model.OAuthCredentialId){
            params.OAuthCredentialId = model.OAuthCredentialId;
        }

        return params;
    }

    validateEmailServerUpdate() {
        let currentEmailServerModel = this.model.get('currentEmailServerDetails');
        //Server & User
        if (!currentEmailServerModel.Address ||
            !currentEmailServerModel.DisplayName ||
            !currentEmailServerModel.EmailAddress ||
            !currentEmailServerModel.Port) {
            return false;
        }
        //Misc
        if (currentEmailServerModel.requireSecondaryEmailServer === 'True' &&
            Number(currentEmailServerModel.SecondaryEmailServerID) === -1) {
            return false;
        }
        if (currentEmailServerModel.SendFailureEmail === 'True' &&
            !currentEmailServerModel.SendFailureEmailFrequency &&
            !currentEmailServerModel.SendFailureEmailAddress) {
            return false;
        }
        //Advance
        if (currentEmailServerModel.RequiresAuthentication === 'True') {
            const password = $('input[type=password]').val();
            if (!currentEmailServerModel.UserName || !password) {
                return false;
            }
        }
        return true;
    }

    applyChanges() {
        let currentModel = this.model.get('currentEmailServerDetails');
        console.log("Applying Changes", currentModel);

        const emailServerName = $('input[name="Name"]').val();
        if (!emailServerName) {
            let simpleModal = new SimpleConfirmModal({
                model: new Model({
                    subtitle: "Update Email Server",
                    confirmationText: constants.EMAIL_SERVER_ERROR_TEXT,
                    height: 200,
                    width: 400
                })
            });
            simpleModal.render().then((result) => {
                return;
            }).catch((err) => {
                console.log('Error Showing Email Server ', err);
                NotificationService.error('Error Showing Email Server ' + err.MESSAGE);
            });
        } else if (this.validateEmailServerUpdate()) {
            this.updateEmailServerSettings();
        }
        else {
            let simpleConfirmModal = new SimpleConfirmModal({
                model: new Model({
                    confirmationText: constants.EMAIL_SERVER_WARNING_TEXT,
                    subtitle: 'Email Server Warning',
                    height: 300,
                    width: 500
                })
            });
            simpleConfirmModal.render().then((result) => {
                if (result === 'Ok') {
                    this.updateEmailServerSettings();
                }
                else {
                    this.cancelChanges();
                }
            }).catch((err) => {
                console.log('Error Applying changes on Server Details', err);
                NotificationService.error('Error Applying changes on Server Details' + err.MESSAGE);
            });
        }
    }

    deleteServer(ev) {
        dashboardService.deleteUserEmailServer();
    }

    cancelChanges() {
        console.log('Canceling Changes');
        this.model.set('currentEmailServerDetails', Object.assign({}, this.model.get('emailServerDetails')), { silent: true });
        this.model.set('hasChanges', false, { silent: true });
        this.render();
    }

    makeDefault() {
        let currentEmailServerId = this.model.get('emailServerId');
        RestService.setAccountDefaultEmailServer(currentEmailServerId).then((response) => {
            console.log("Email Server Default Response", response);
            eventBus.trigger(constants.EV_UPDATE_EMAIL_SERVER_DETAILS, this.model.get('emailServerId'));
        }).catch((err) => {
            console.log('Error Applying changes on Set Default Server', err);
            NotificationService.error('Error Applying changes on  Set Default Server' + err.MESSAGE);
        });
    }

    makeDeleteServer(emailServerId) {
        RestService.deleteEmailServer(emailServerId).then((response) => {
            console.log("Email Server Delete", response);
            eventBus.trigger(constants.EV_DELETE_EMAIL_SERVER, this.model.get('emailServerId'));
        }).catch((err) => {
            console.log('Error Deleting Email Server', err);
            NotificationService.error('Error Deleting Email Server' + err.MESSAGE);
        });
    }
    //
    clearDefault() {
        RestService.setAccountDefaultEmailServer().then((response) => {
            console.log("Account Default Response", response);
            eventBus.trigger(constants.EV_UPDATE_EMAIL_SERVER_DETAILS, this.model.get('emailServerId'));
        }).catch((err) => {
            console.log('Error Applying changes on Clear Default Server', err);
            NotificationService.error('Error Applying changes on  Set Default Server' + err.MESSAGE);
        });
    }

    testEmailServer(ev) {
        let testEmailServerModal = new TestEmailServerModal({ model: new Model({ subtitle: "Test Email Server", subject: 'Test' }) });
        testEmailServerModal.render().then((result) => {
            if (!$.isEmptyObject(result)) {
                this.makeEmailServerTest(this.model.get('emailServerId'), result.email, result.subject)
            }
        }).catch((err) => {
            console.log('Error Testing Email Server ', err);
            NotificationService.error('Error Testing Email Server' + err.MESSAGE);
        });
    }

    makeEmailServerTest(emailServerId, email, subject) {
        RestService.testEmailServer(emailServerId, email, subject).then((response) => {
            let testEmailConfirmationModal = new TestEmailConfirmationModal({ model: new Model({}) });
            testEmailConfirmationModal.render().then((result) => {
                return;
            }).catch((err) => {
                NotificationService.error('Error Testing Email Server' + err.MESSAGE);
            });
        }).catch((err) => {
            console.log('Call to email server failed. ', err.MESSAGE['#cdata-section'] || err.MESSAGE);
            let errorMessage = err.MESSAGE['#cdata-section'] || err.MESSAGE;
            NotificationService.error('Call to email server failed. ' + (errorMessage ? errorMessage : ''));
        });
    }

    getEmailServerProviders() {
        
        RestService.getEmailSendProviders().then((response) => {
            const servers = util.enforceArrayType(response);
            this.model.set('serverProviders', servers, { silent: true });
        }).catch((err) => {
            console.log('Error retrieving email servers', err);
            NotificationService.error('Error retrieving email servers' + err.MESSAGE);
        });
    }

    setEmailServersProviders() {
        let servers = this.model.get('serverProviders');
        let option;
        $.each(servers, (i, server) => {
            server.AuthMethod = 2;
            option = $("<option>", {
                value: server['@EmailSendProviderId'],
                text: server['@Name']
            });
            $('#EmailSendProviderId').append(option);
            option[0].dataset.method = server.AuthMethod;
        });
    }

    getEmailServerTypeDetails(providerID) {
        $("#getToken").off('click');
        $("#getToken").on('click', (ev) => {
            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
            RestService.getOAuthAuthorizationURL(providerID).then((response) => {
                this.redirectSignIn(response.Uri["@value"]);
                spinner.stop();
            }).catch((err) => {
                console.log('Error retrieving OAuth authorization URL', err);
                NotificationService.error('Error retrieving OAuth authorization URL' + err.MESSAGE);
                spinner.stop();
            });
        });

    }

    render() {
        const html = this.template(this.model.toJSON());

        $(this.$el[0]).html(html);

        let currentModel = this.model.get("currentEmailServerDetails");

        //Wait for the servers to be fetched with the services
        if (!this.model.get("serverProviders")) {
            const waitForServers = setInterval(() => {
                if (this.model.get("serverProviders")) {
                    this.setEmailServersProviders();
                    this.changeLayout(currentModel.EmailSendProviderId, currentModel.AuthMethod);
                    clearInterval(waitForServers);
                }
                else {
                    return;
                }
            }, 50);
        }
        else{
            this.setEmailServersProviders();
            this.changeLayout(currentModel.EmailSendProviderId, currentModel.AuthMethod);
        }

        // Choosing options from Model
        $(`select[name='SMTPTimeout'] option[value="${currentModel.SMTPTimeout}"]`).prop('selected', true);
        $(`select[name='NoofRetry'] option[value="${currentModel.NoofRetry}"]`).prop('selected', true);
        $(`select[name='SecondaryEmailServerID'] option[value="${currentModel.SecondaryEmailServerID}"]`).prop('selected', true);
        $(`select[name='SendFailureEmailFrequency'] option[value="${currentModel.SendFailureEmailFrequency}"]`).prop('selected', true);

        this.delegateEvents();
        this.$el.css('cursor', 'default');
        return this;
    }

    refresh() {
        if (this.model.get('hasChanges')) {
            let simpleModal = new SimpleConfirmModal({
                model: new Model({
                    subtitle: `Email Server Details - ${this.model.get("emailServerDetails").Name}`,
                    confirmationText: `Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height: 200,
                    width: 400
                })
            });
            simpleModal.render().then((result) => {
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_EMAIL_SERVER_DETAILS, this.model.get('emailServerId'))
                }
            }).catch((err) => {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else {
            eventBus.trigger(constants.EV_REFRESH_EMAIL_SERVER_DETAILS, this.model.get('emailServerId'))
        }
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
}

export default EmailServerDetailsView;
